import { createContext } from '@synoptic/ui-kit/utils/create-context.js';

export type NavVariantV2 = 'expanded' | 'rail' | 'bar' | 'menu';

export const [NavVariantV2Provider, useNavVariantV2] =
  createContext<NavVariantV2>('NavVariantV2');
